// @flow

export default class HomeFeatures {
  tv_room: boolean;
  yard: boolean;
  balcony: boolean;
  garden: boolean;
  terrace: boolean;
  furnished: boolean;
  equipped: boolean;
  air_conditioner: boolean;
  heating: boolean;
  kitchen: boolean;
  universal_access: boolean;
  lobby: boolean;
  jacuzzi: boolean;
  pool: boolean;
  sauna: boolean;
  gym: boolean;
  security: boolean;
  cinema: boolean;
  elevator: boolean;
  games: boolean;
  roof_garden: boolean;
  roof: boolean;
  events_room: boolean;
  tennis_court: boolean;
  visits_space: boolean;
  roaster: boolean;
  green_areas: boolean;
  cistern: boolean;
  squash_court: boolean;
  light: boolean;
  gas: boolean;
  water: boolean;
  cable: boolean;
  telephone: boolean;
  wifi: boolean;
  cleaning_service: boolean;
  pet_friendly: boolean;
  babies: boolean;
  kids: boolean;
  parties: boolean;
  smokers: boolean;
  service_room: boolean;
  bowling: boolean;

  constructor(data: any = {}) {
    this.tv_room = data.tv_room || false;
    this.yard = data.yard || false;
    this.balcony = data.balcony || false;
    this.garden = data.garden || false;
    this.terrace = data.terrace || false;
    this.furnished = data.furnished || false;
    this.equipped = data.equipped || false;
    this.air_conditioner = data.air_conditioner || false;
    this.heating = data.heating || false;
    this.kitchen = data.kitchen || false;
    this.universal_access = data.universal_access || false;
    this.lobby = data.lobby || false;
    this.jacuzzi = data.jacuzzi || false;
    this.pool = data.pool || false;
    this.sauna = data.sauna || false;
    this.gym = data.gym || false;
    this.security = data.security || false;
    this.cinema = data.cinema || false;
    this.elevator = data.elevator || false;
    this.games = data.games || false;
    this.roof_garden = data.roof_garden || false;
    this.roof = data.roof || false;
    this.events_room = data.events_room || false;
    this.tennis_court = data.tennis_court || false;
    this.visits_space = data.visits_space || false;
    this.roaster = data.roaster || false;
    this.green_areas = data.green_areas || false;
    this.cistern = data.cistern || false;
    this.squash_court = data.squash_court || false;
    this.light = data.light || false;
    this.gas = data.gas || false;
    this.water = data.water || false;
    this.cable = data.cable || false;
    this.telephone = data.telephone || false;
    this.wifi = data.wifi || false;
    this.cleaning_service = data.cleaning_service || false;
    this.pet_friendly = data.pet_friendly || false;
    this.babies = data.babies || false;
    this.kids = data.kids || false;
    this.parties = data.parties || false;
    this.smokers = data.smokers || false;
    this.service_room = data.service_room || false;
    this.bowling = data.bowling || false;
  }
}
